
import Vue from 'vue';
import { i18nPlugin } from '@sailor/i18n-vue';
import resources from './assets/locales/resources';

Vue.use(i18nPlugin, (i18nClient) => {
    i18nClient.init({
        resources,
        ns: 'b_fe_vss',
    }, () => {
        window.i18nClient = i18nClient;
        window.getText = i18nClient.t;
    });
});
